import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useProperty } from "@/contexts/PropertyContext";
import { PageHeader } from "@/components/PageHelpers";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function PetApprovalsPage() {
  const { propertyId } = useProperty();
  const [items, setItems] = useState([]);
  const load = async () => { const { data } = await api.get(`/pets?property_id=${propertyId}`); setItems(data.items); };
  useEffect(() => { if (propertyId) load(); }, [propertyId]);
  const decide = async (id, decision) => { await api.patch(`/pets/${id}/decide`, { decision }); toast.success("Recorded"); load(); };
  return (
    <div>
      <PageHeader eyebrow="Admin Tools" title="Pet Approvals" subtitle="Review resident-submitted pets." />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.map((p) => (
          <Card key={p.id} className="border-white/10 bg-card p-5">
            <div className="flex items-center justify-between">
              <div>
                <div className="text-lg font-semibold">{p.pet_name}</div>
                <div className="text-xs text-zinc-500">{p.species} · {p.breed} · {p.weight_lbs} lbs</div>
                <div className="text-xs text-zinc-500 mt-1">{p.resident_name} · Unit {p.unit}</div>
              </div>
              <Badge variant="outline" className="border-white/10 capitalize">{p.status}</Badge>
            </div>
            {p.status === "pending" && (
              <div className="mt-4 flex gap-2">
                <Button size="sm" onClick={() => decide(p.id, "approved")} data-testid={`pet-approve-${p.id}`} className="bg-emerald-600 hover:bg-emerald-700">Approve</Button>
                <Button size="sm" variant="outline" onClick={() => decide(p.id, "denied")} className="border-rose-500/40 text-rose-300">Deny</Button>
              </div>
            )}
          </Card>
        ))}
        {items.length === 0 && <div className="text-sm text-muted-foreground">No pets registered.</div>}
      </div>
    </div>
  );
}
